import { render, staticRenderFns } from "./Sly.vue?vue&type=template&id=bb18dde0&"
import script from "./Sly.vue?vue&type=script&lang=js&"
export * from "./Sly.vue?vue&type=script&lang=js&"
import style0 from "./Sly.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports